import { createGlobalState, useTimeoutFn } from '@vueuse/core'
import {
  PERSISTENT_TOAST_KINDS,
  TOAST_REMOVE_TIMEOUT_DURATION_IN_MILLISECONDS,
} from 'src/tpbp-core/models/toaster/toaster.constants'
import type { Toast } from 'src/tpbp-core/models/toaster/toaster.types'
import type { ToastView } from 'src/tpbp-ds/components/toaster-container/toast-view.types'
import { computed, ref } from 'vue'
import { mapToastsToToastViews } from './toaster.mapper'

export const useToasterStore = createGlobalState(() => {
  const _toasts = ref<Toast[]>([])

  function removeToast(index: number): void {
    _toasts.value.splice(index, 1)
  }

  function _removeToastAfterTimeout(toast: Toast): void {
    useTimeoutFn(() => {
      const index = _toasts.value.indexOf(toast)

      if (index === -1) return

      removeToast(index)
    }, TOAST_REMOVE_TIMEOUT_DURATION_IN_MILLISECONDS)
  }

  return {
    toastViews: computed((): ToastView[] =>
      mapToastsToToastViews(_toasts.value),
    ),
    hasToasts: computed((): boolean => _toasts.value.length > 0),

    removeToast,
    addToast(toast: Toast) {
      _toasts.value.push(toast)

      if (PERSISTENT_TOAST_KINDS.has(toast.kind)) return

      _removeToastAfterTimeout(toast)
    },
    clearToaster() {
      _toasts.value.splice(0)
    },
  }
})
